import { gql } from '@common/hooks';

export type SignOutAllVariables = {
  input: {
    membershipId: string;
    token: string;
  }[];
};

export type SignOutAllResponse = {
  signOutAll: {
    success: boolean;
  };
};

export const SignOutAll = gql`
  mutation signOutAll($input: [SignOutWorksUserInput!]!) {
    signOutAll(input: $input) {
      success
    }
  }
`;
